export default {"src":"/_next/static/media/PizzaDAY.3a01893e.svg","height":418,"width":418,"blurWidth":0,"blurHeight":0};